const GAP = 24;

const RESERVED_KEYS = [
  "swiperSelector",
  "sectionClass",
  "navPrevClass",
  "navNextClass",
];

/**
 * Reusable Swiper initializer for content sliders (e.g. card-slider, testimonial-slider).
 * @param {Object} config
 * @param {string} config.swiperSelector - Selector for the swiper container (e.g. '.card-slider__swiper')
 * @param {string} config.sectionClass - Class of parent section (e.g. 'card-slider')
 * @param {string} config.navPrevClass - Class for prev button (e.g. 'card-slider__nav--prev')
 * @param {string} config.navNextClass - Class for next button (e.g. 'card-slider__nav--next')
 * @param {number} config.slidesPerView - Default slides per view
 * @param {Object} [config.breakpoints] - Swiper breakpoints (optional override)
 * @param {Object} [config.*] - Any other Swiper options (e.g. loop, autoplay) are passed through
 */
export const initContentSlider = (config) => {
  const {
    swiperSelector,
    sectionClass,
    navPrevClass,
    navNextClass,
    slidesPerView = 1,
    breakpoints = {},
  } = config;

  const swiperOptions = {
    slidesPerView,
    spaceBetween: GAP,
    navigation: {},
    breakpoints: Object.keys(breakpoints).length ? breakpoints : undefined,
  };
  Object.keys(config).forEach((key) => {
    if (RESERVED_KEYS.includes(key)) return;
    if (key === "breakpoints") return;
    swiperOptions[key] = config[key];
  });

  const containers = document.querySelectorAll(swiperSelector);
  if (!containers.length) return;

  containers.forEach((el) => {
    const section = el.closest(`.${sectionClass}`);
    const prevEl = section?.querySelector(`.${navPrevClass}`);
    const nextEl = section?.querySelector(`.${navNextClass}`);

    const swiper = new Swiper(el, {
      ...swiperOptions,
      navigation: {
        nextEl,
        prevEl,
      },
    });

    section?.querySelectorAll(`.${navPrevClass}`).forEach((btn) => {
      if (btn !== prevEl) btn.addEventListener("click", () => swiper.slidePrev());
    });
    section?.querySelectorAll(`.${navNextClass}`).forEach((btn) => {
      if (btn !== nextEl) btn.addEventListener("click", () => swiper.slideNext());
    });
  });
};
